import type { PageHelpContent } from './helpTypes';
import { resolveHelpFromCatalog } from './helpCatalog';

/** Último recurso si la URL no coincide con ninguna guía registrada (rutas nuevas o rutas públicas fuera del layout). */
const helpGeneric: PageHelpContent = {
  title: 'Ayuda',
  intro:
    'Esta pantalla puede ser una vista nueva o una ruta no mapeada aún en la guía. Podés navegar desde el menú lateral o volver al menú principal.',
  sections: [
    {
      id: 'navegacion',
      title: 'Navegación',
      bullets: [
        'Usá “Volver al menú” cuando estés en un submenú para ver todas las opciones del módulo.',
        'El ícono de ayuda en la barra superior abre siempre la guía de la ruta actual.',
      ],
    },
    {
      id: 'soporte',
      title: '¿Necesitás más ayuda?',
      body:
        'Si esta pantalla debería tener instrucciones específicas, avisá a soporte o al administrador para incorporarla. Los procedimientos de AFIP y políticas internas las define tu empresa.',
    },
  ],
};

/**
 * Normaliza pathname (sin query) y resuelve el contenido de ayuda.
 */
export function resolveHelpContent(pathname: string): PageHelpContent {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return resolveHelpFromCatalog(normalized) ?? helpGeneric;
}

export function getFallbackHelpContent(): PageHelpContent {
  return helpGeneric;
}
